import {makeAutoObservable} from 'mobx';

import type {
  ProposedMembership,
  RegularInvite,
} from '../../../stores/Invites/types';
import type {ProgramInvite} from '../types';
import type {IProgramInviteDataModel} from './types';

import {getEntityTypeById} from '../../../../../utils/entity/getEntityType';
import {ProposedMembershipModel} from './ProposedMembershipModel';
import {RegularInviteModel} from './RegularInviteModel';

export class ProgramInviteModel {
  private dataModel: IProgramInviteDataModel;

  constructor(invite: ProgramInvite) {
    const entityType = getEntityTypeById(invite._id);

    this.dataModel =
      entityType === 'membership'
        ? new ProposedMembershipModel(invite as ProposedMembership)
        : new RegularInviteModel(invite as RegularInvite);

    makeAutoObservable(this, undefined, {
      autoBind: true,
    });
  }

  get avatar() {
    return this.dataModel.avatar;
  }

  get courseLabel() {
    return this.dataModel.courseLabel;
  }

  get initialEmail() {
    return this.dataModel.initialEmail;
  }

  get isInviteByEmail() {
    return this.dataModel.isInviteByEmail;
  }

  get label() {
    return this.dataModel.label;
  }

  get message() {
    return this.dataModel.message;
  }

  get name() {
    return this.dataModel.name;
  }
}
